// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3I6Be","paramInput":"JobSimulator_paramInput__2tJgl","input":"JobSimulator_input__3zgMM"};